import { useAtomValue } from 'jotai';
import { useDispatch } from 'modules/react-redux';
import { changeNetSuiteRequest } from 'pages/requestForm/actions';
import { useCallback } from 'react';
import { hasChangesState } from 'shared/states';

export const useChangeNetSuiteRequest = () => {
    const hasChanges = useAtomValue(hasChangesState);
    const dispatch = useDispatch();

    return useCallback(() => {
        if (!hasChanges) {
            dispatch(changeNetSuiteRequest());
        }
    }, [dispatch, hasChanges]);
};
